import PropTypes from "prop-types"
import React, { useContext } from "react"
import { Link } from "gatsby-plugin-intl"
import Burger from "./burger"
import Menu from "./menu"
import MenuContext from "./menuContext"

const Header = ({ siteTitle }) => {
  const contextValue = useContext(MenuContext)

  return (
    <header
      style={{
        display: "flex",
        justifyContent: "space-between",
        position: "absolute",
        padding: "2rem",
        width: "100%",
        zIndex: "9999",
      }}
    >
      <h1 style={{ margin: 0, fontSize: "1.5rem" }}>
        <Link
          to="/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          {siteTitle}
        </Link>
      </h1>
      <Burger open={contextValue.open} setOpen={contextValue.openMenu} />
      <div className="menu-header">
        <Menu />
      </div>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
